//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Paper, Button, TextField, Box, Tooltip, MenuItem, InputAdornment, IconButton, Typography } from '@mui/material';
//MUI ICONS
import { Queue, Clear, Search, Panorama, QrCode, SimCardDownload, EditDocument } from '@mui/icons-material';
//CONTOLLERS
import ApiController from '../../controllers/api';

//CUSTOM COMPONENTS
import CustomModal from '../CustomModal';
import CustomBackdrop from '../CustomBackdrop';
import PreviewPhoto from '../preview';
import FormCreateInventory from './catalogForms/formCreateInventory';
import FormEditInventory from './catalogForms/formEditInventory';
import VerifyAgreement from '../verifyAgreement';
//OTHERS
import Swal from 'sweetalert2';
// COMPONENTS DATAGRID
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';

import { usePermissions } from '../../hooks/usePermission';

export default function CatalogInventory() {
  const [selectedId, setSelectedIdState] = React.useState(null);// ESTADO PARA GUARDAR EL ID SELECCIONADO
  const [filterValue, setFilterValue] = React.useState('');
  const [getValues, setGetValues] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(null);
  const [openBackdrop, setOpenBackdrop] = React.useState(true);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const { isAuthenticated, canCreate, canEdit, canDelete, canDownload, canExport, canViewInventory } = usePermissions();

  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);
  const downloadQR = async (data) => {
  const res = await apiInstance.downloadPDFWithIDs(`/inventory/download/`, data);
  if(!res.success)
    Swal.fire({
      title: '¡ERROR! ❌',
      icon: 'error',
      text: 'NO SE PUDEDE DESCARGAR LAS ETIQUETAS QR EN ESTE MOMENTO',
      showConfirmButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor:'#ef7474',
      confirmButtonText: 'CONFIRMAR',
      padding: '0 0 20px'
  });
  }
  const apiRef = useGridApiRef();
  
  const getData = async () => {
  const response = await apiInstance.get('/inventory');
    if (response.success){
       setGetValues(response.data);
    }else if(!response.success){
        Swal.fire({
            title: '¡ERROR! ❌',
            icon: 'error',
            text: 'NO SE PUDIERÓN CARGAR LOS DATOS',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor:'#ef7474',
            confirmButtonText: 'CONFIRMAR',
            padding: '0 0 20px'
        });
    }
      setOpenBackdrop(false);
  }

  React.useEffect(() => {
    if(!isAuthenticated || !canViewInventory)return;
    getData();
  }, []);

  const handleOpen = (modalType, id = null) => {
    setOpenModal(modalType);
    if (id === null) return; 
    setSelectedIdState(id);
  };

  const handleExport = () => {// EXPORTAR SOLO LAS FILAS SELECCIONADAS
  apiRef.current.exportDataAsCsv({
    fileName: 'NOPALA DE VILLAGRÁN - SISTEMA DE INVENTARIOS MUNICIPAL (CATALOGO DE INVENTARIOS)',
    fields: columns.filter(col => !col.disableExport).map(col => col.field),
    getRowsToExport: () => rowSelectionModel,
    utf8WithBom: true
  });
  };

  const handleClose = () => setOpenModal(null);
  const columns = React.useMemo(() => [
    { field: 'CODIGO', headerName: 'CÓDIGO DE INVENTARIO', width: 170 , type: 'text'},
    { field: 'COSTO', headerName: 'COSTO', width: 110 , type: 'number', valueGetter: (value, row) => `$${value}`},
    { field: 'MARCA', headerName: 'MARCA', width: 100 , type: 'text'},
    { field: 'MODELO', headerName: 'MODELO', width: 100 , type: 'text'},
    { field: 'SERIE', headerName: 'NO. SERIE', width: 100 , type: 'text'},
    { field: 'ESTADO', headerName: 'ESTADO FÍSICO', width: 150 , type: 'text'},
    { field: 'FACTURA', headerName: 'FACTURA', width: 100 , type: 'text'},
    { field: 'FECHA_ADQUISICION', headerName: 'FECHA ADQUISICIÓN', width: 100 , type: 'date',
      valueGetter: (value, row) => {
         if (!value) return null;
          const date = new Date(value);
          return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate()
          );
        },
      valueFormatter: (value) => {
        if (!value) return "N/A";
        return new Date(value).toLocaleDateString("es-MX", {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      }
    },
    { field: 'POLIZA', headerName: 'PÓLIZA', width: 100 , type: 'text'},
    { field: 'INVENTARIO_ANTERIOR', headerName: 'INVENTARIO ANTERIOR', width: 190 , type: 'text'},
    { field: 'PROVEEDOR', headerName: 'PROVEEDOR', width: 120 , type: 'text'},
    { field: 'DESCRIPCION_FISICA', headerName: 'DESCRIPCIÓN FÍSICA', width: 500 , type: 'text',
    renderCell: (params) => (
      <Typography
        variant="body2"
        style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'auto',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal'
          }}
        >
        {params.value}
      </Typography>
      ),
    },
    { field: 'OBSERVACIONES', headerName: 'OBSERVACIONES', width: 300 , type: 'text',
    renderCell: (params) => (
      <Typography
        variant="body2"
        style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'auto',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal'
          }}
        >
        {params.value}
      </Typography>
      ),
    },
    { field: 'AREA', headerName: 'ÁREA', width: 300 , type: 'text'},
    { field: 'EDIFICIO', headerName: 'EDIFICIO', width: 300 , type: 'text'},
    { field: 'PARTIDA', headerName: 'PARTIDA', width: 300 , type: 'text'},
    { field: 'BIEN', headerName: 'BIEN', width: 300 , type: 'text'},
    { field: 'RESGUARDANTE', headerName: 'RESGUARDANTE', width: 300 , type: 'text'},
    { field: 'ASIGNACION',
      headerName: 'ESTADO DE RESGUARDO',
      width: 200,
      type: 'text',
      align: 'center',
      disableExport:true,
      renderCell: (params)=> {
      const isAsign = (params.row.ASIGNACION);
      const backgroundColor = isAsign ? "#d4edda" : "#d9d7f8ff";
      const borderColor = isAsign ? "#28a745" : "#3540dcff";
      const textColor = isAsign ? "#155724" : "#1c1f72ff";
      return (
        <Tooltip title={isAsign ? 'ESTE BIEN YA SE ENCUENTRA DE UN VALE DE RESGUARDO' : 'ESTE BIEN AUN NO ESTA DENTRO DE UN VALE DE RESGUARDO'} placement="bottom-start">
        <div 
        style={{ 
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        padding:"2px 20px",
        borderRadius: "12px",
        border: `1px solid ${borderColor}`,
        background: backgroundColor,
        color: textColor,
        lineHeight: "16px",
        cursor:"help"
        }}>
        {isAsign ? 'EN RESGUARDO' : 'SIN RESGUARDO'}
        </div>
        </Tooltip>
      )}
    },
    {
      field: 'ACCIONES',
      headerName: 'ACCIONES',
      sortable: false,
      flex: 1,
      minWidth: 245,
      disableExport: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: "break-word", width: "fit-content" }}>
          <Tooltip title="VER FOTO" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="warning"
              onClick={() => handleOpen("preview", params.row.IMAGEN)}
              style={{ marginRight: 10 }}
            >
              <Panorama/>
            </Button>
          </Tooltip>
          {canEdit && (
          <Tooltip title="EDITAR" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => handleOpen("edit", params.row.ID)}
              style={{ marginRight: 10 }}
            >
              <EditDocument />
            </Button>
          </Tooltip>
          )}
          {canDelete && (
          <Tooltip title="DAR DE BAJA" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="error"
              style={{ marginRight: 10 }}
              onClick={() => handleOpen("verify-agreement", params.row.ID)}
            >
              <SimCardDownload />
            </Button>
          </Tooltip>)}
        </div>
      )
    }
  ], [canEdit, canDelete]);
  
  const filterableColumns = columns.filter(col => 
    col.field !== 'ACCIONES' && 
    col.field !== 'IMAGEN' &&
    col.field !== 'ESTADO'&&
    col.field !== 'DESCRIPCION_FISICA' &&
    col.field !== 'OBSERVACIONES' &&
    col.field !== 'COSTO' && 
    col.field !== 'MARCA' &&
    col.field !==  'MODELO' &&
    col.field !== 'FACTURA' &&
    col.field !== 'POLIZA' &&
    col.field !== 'PROVEEDOR' &&
    col.field !== 'ASIGNACION'
  );

  const [filterColumn, setFilterColumn] = React.useState(filterableColumns[0].field);
  const currentColumnType = columns.find(col => col.field === filterColumn)?.type || 'text';
  const filteredRows = React.useMemo(() => {
    if (!filterValue) return getValues || [];
    return (getValues || []).filter(row => {
      const value = row[filterColumn];
      if (value === null || value === undefined) return false;
      return value.toString().toLowerCase().includes(filterValue.toLowerCase());
    });
  }, [getValues, filterColumn, filterValue]);

  return (
    <>
      <Paper sx={{ background: "transparent", border: "none", boxShadow:"none", height: "auto", width: '90%', minWidth: 300, p: 2, margin: "auto", marginTop: "100px" }}>
        <Typography variant="h6" fontWeight={500}>INVENTARIO DE <b>BIENES MUEBLES E INMBUEBLES</b></Typography>
      </Paper>
      <Paper sx={{ height: "auto", width: '90%', minWidth:300, p: 2, margin: "auto", marginBottom: "50px" }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap'}}>
          <TextField
            select
            label="BUSCAR POR"
            value={filterColumn}
            onChange={e => setFilterColumn(e.target.value)}
            size="small"
          >
            {filterableColumns.map(col => (
              <MenuItem key={col.field} value={col.field}>{col.headerName}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="BUSCAR"
            variant="outlined"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            size="small"
            type={currentColumnType}
            autoComplete='false'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {filterValue && (
                    <IconButton
                      aria-label="clear search"
                      onClick={() => setFilterValue("")}
                      edge="end"
                    >
                      <Clear />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
          {canCreate && ( 
          <Tooltip title="AGREGAR INVENTARIO" placement="bottom-start">
            <Button variant="contained" size="small" color="success" onClick={() => handleOpen("create")}>
              <Queue/>
            </Button>
          </Tooltip>
          )}
          
          {canDownload && (          
          <Tooltip title="DESCARGAR QR" placement="bottom-start">
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => downloadQR(rowSelectionModel)}
              disabled={rowSelectionModel.length === 0}
            >
              <QrCode/>
            </Button>
          </Tooltip>
          )}
          {canExport && (
          <Tooltip title="EXPORTAR A SVG" placement="bottom-start">
              <Button
              variant="contained" 
              size="small"
              onClick={handleExport}
              disabled={rowSelectionModel.length === 0}
              sx={{
                backgroundColor: "#aac101ff",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#9baf02ff"
                }
              }}
              >
                <SimCardDownload/>
              </Button>
          </Tooltip>
          )}
        </Box>
        {/* TABLA */}
        <DataGrid
          apiRef={apiRef}//REFERENCIA PARA EXPORTAR
          disableColumnMenu// DESACTIVA EL MENU DE COLUMNA
          checkboxSelection// HABILITA LA SELECCIÓN DE FILAS
          disableRowSelectionOnClick// EVITA QUE SELECCIONE LA FILA AL DAR CLICK EN ELLA
          rows={filteredRows}// FILAS A MOSTRAR
          columns={columns}// COLUMNAS A MOSTRAR
          getRowHeight={() => 50}// ALTO DE FILA AUTOMATICO
          getRowId={(row) => row.ID}// LLAVE UNICA DE CADA FILA
          // showCellVerticalBorder
          // showColumnVerticalBorder
          sx={{
            '& .MuiDataGrid-cell': {
              borderRight: '1px solid #f7f8f8',
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '3px solid #823c3c',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid #f7f8f8',
            }
          }}
          initialState={{ pagination: { paginationModel: { page: 0, pageSize: 10 } } }}// ESTADO INICIAL DE LA PAGINACION
          pageSizeOptions={[5, 10, 15, 20, 25, 30]}// OPCIONES DE PAGINACION
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}// IDIOMA A ESPAÑOL
          onRowSelectionModelChange={(newSelection) => {// OBTENER LAS FILAS SELECCIONADAS
            if (!newSelection) return;
              setRowSelectionModel(Array.from(newSelection.ids));
          }}
        />
        {/* MODALES */}
        <CustomModal open={openModal === 'edit'} onClose={handleClose} id={selectedId} Component={FormEditInventory} refreshArea={getData} />
        <CustomModal open={openModal === 'verify-agreement'} onClose={handleClose} id={selectedId} Component={VerifyAgreement} refreshData={getData} />
        <CustomModal open={openModal === 'create'} onClose={handleClose} Component={FormCreateInventory} refreshArea={getData}/>
        <CustomModal open={openModal === 'preview'} onClose={handleClose} Component={PreviewPhoto} id={selectedId}/>
      </Paper>
      <CustomBackdrop open={openBackdrop}/>
    </>
  );
}